module.exports = __webpack_public_path__ + "static/media/hamburguesas-y-picadas.4e3673c5.jpg";